import styled from 'styled-components';
import ExplainabilityInfoMenu from '../explainability-info-menu.component';
import { CaptionFont } from '../../../../../themes/fonts';
import { THEME } from '../../../../../themes';
import { SectionText } from '../explainability-info-menu.styled';
import { FLUENT_UI_EMOJIS } from '../../../../../assets';

export const Container = styled(ExplainabilityInfoMenu)<{ isExactFundingStage: boolean }>`
  background-image: ${({ isExactFundingStage }) => {
    if (isExactFundingStage) {
      return 'linear-gradient(to bottom, rgba(52, 204, 102, 0.05), rgba(52, 204, 102, 0))';
    }
    
    return 'linear-gradient(to bottom, rgba(0, 0, 64, 0.05), rgba(52, 204, 102, 0))';
  }};
`;

export const CompanyFundingStageTagIcon = styled(FLUENT_UI_EMOJIS.MONEY_BAG)`
  height: 16px;
  width: 16px;
`;

export const TagContainer = styled.div`
  display: flex;
  gap: ${THEME.SPACING.TINY};
  align-items: center;
`;

export const HeaderDescription = styled(SectionText)`
  ${CaptionFont};
  margin-top: ${THEME.SPACING.TINY};
  margin-bottom: ${THEME.SPACING.TINO};
`;
